import { StudentTicket } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    studentTicketSearchParams: {},
    studentTickets: [],
    pageText: '',
    totalItems: 0,
    itemsPerPage: 5,
  },
  actions: {
    async searchStudentTickets({ commit, state, dispatch }, query) {
      const studentTicketsSearchParams = {
        _limit: state.itemsPerPage,
        ...query,
      }
      commit('changeState', { studentTicketsSearchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.studentTicketsSearchParams) {
        let studentTicketsSearchParams = {
          ...state.studentTicketsSearchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
        }
        const [totalItems, studentTickets] = await Promise.all([
          StudentTicket.qsCount(studentTicketsSearchParams),
          StudentTicket.qsFetch(studentTicketsSearchParams),
        ])
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            studentTickets,
            totalItems,
            itemsPerPage,
            studentTicketsSearchParams,
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
    },
    async getOneStudentTicket({ commit }, params) {
      const { id, ...options } = params
      const studentTicket = await StudentTicket.fetchOne(id, options)
      commit('updateStudentTicket', studentTicket)
      return studentTicket
    },
    async getManyStudentTickets({ commit }, { searchParams, disableSave = false }) {
      if (!disableSave) {
        commit('setStudentTickets', [])
      }
      const studentTickets = await StudentTicket.qsFetch(searchParams)
      if (!disableSave) {
        commit('setStudentTickets', studentTickets)
      }
      return studentTickets
    },
    async getAllStudentTickets({ commit }, { searchParams, disableSave = false }) {
      if (!disableSave) {
        commit('setStudentTickets', [])
      }
      const studentTickets = await StudentTicket.fetch({ ...searchParams, _limit: -1, _start: 0 })
      if (!disableSave) {
        commit('setStudentTickets', studentTickets)
      }
      return studentTickets
    },
    async getStudentTicketCount(_, params) {
      const studentTicketCount = await StudentTicket.qsCount(params)
      return studentTicketCount
    },
    async createStudentTicket({ commit }, userData) {
      const newStudentTicket = await StudentTicket.create({
        ...userData,
        code: userData.username,
      })
      commit('setStudentTickets', [newStudentTicket])
      return newStudentTicket
    },
    async updateStudentTicket({ commit }, { id, ...updateStudentTicketData }) {
      return StudentTicket.update(id, updateStudentTicketData)
    },
    async updateStudentTickets({ dispatch }, items) {
      await Promise.all(items.map((item) => dispatch('updateStudentTicket', item)))
    },
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    setStudentTickets(state, studentTickets) {
      state.studentTickets = studentTickets
    },

    updateStudentTicket(state, studentTicket) {
      state.studentTickets = state.studentTickets.map((s) => {
        if (s.id === studentTicket.id) {
          return { ...s, ...studentTicket }
        }
        return s
      })
    },
    removeStudentTicket(state, studentTicket) {
      state.studentTickets = state.studentTickets.filter((s) => {
        return s.id !== studentTicket.id
      })
    },
  },
}
